<template>
  <svg
    width="194"
    height="215"
    viewBox="0 0 194 215"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84.1477 148.442C106.714 160.301 134.636 151.648 146.513 129.117C158.39 106.585 149.724 78.707 127.157 66.8487C104.591 54.9905 76.6689 63.6428 64.7921 86.1742C52.9153 108.706 61.5812 136.584 84.1477 148.442Z"
      fill="var(--contrastColor)"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M110.325 112.597C113.318 112.554 116.211 111.516 118.547 109.648C120.883 107.78 122.53 105.189 123.227 102.282C123.923 99.3763 123.631 96.3212 122.395 93.5995C121.159 90.8779 119.05 88.6449 116.402 87.2532C113.753 85.8614 110.716 85.3902 107.769 85.914C104.822 86.4377 102.134 87.9266 100.13 90.1454C98.1248 92.3643 96.9174 95.1867 96.6981 98.167C96.4788 101.147 97.2601 104.116 98.9185 106.603L85.8318 117.201C85.3339 117.598 84.9429 118.113 84.6937 118.699C84.4446 119.285 84.3452 119.924 84.4046 120.558C84.4639 121.192 84.68 121.801 85.0336 122.331C85.3871 122.86 85.867 123.294 86.43 123.593L103.37 132.495C103.935 132.789 104.565 132.938 105.203 132.929C105.84 132.92 106.466 132.753 107.022 132.443C107.579 132.133 108.05 131.69 108.393 131.153C108.736 130.616 108.94 130.003 108.986 129.368L110.325 112.597Z"
      fill="white"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M81.7847 152.924C106.831 166.086 137.82 156.483 151.002 131.476C164.184 106.469 154.566 75.5272 129.52 62.366C104.474 49.2049 73.4841 58.8078 60.3024 83.8148C47.1207 108.822 56.7386 139.763 81.7847 152.924Z"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M76.0157 164.876C107.481 181.41 146.412 169.346 162.972 137.93C179.532 106.514 167.449 67.6431 135.984 51.109C104.52 34.5749 65.5878 46.639 49.0278 78.0548C32.4679 109.471 44.5508 148.342 76.0157 164.876Z"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M154.858 43.8099H192.957V5.77051"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M182.648 182.689C167.826 197.525 148.937 207.632 128.372 211.73C107.806 215.828 86.4873 213.733 67.112 205.711C47.7368 197.689 31.1757 184.099 19.5237 166.662C7.87171 149.224 1.65234 128.722 1.65234 107.749C1.65234 86.7754 7.87171 66.2732 19.5237 48.8357C31.1757 31.3981 47.7368 17.8087 67.112 9.78654C86.4873 1.76433 107.806 -0.330261 128.372 3.76774C148.937 7.86574 167.826 17.9722 182.648 32.8087L192.957 42.883"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: [],
};
</script>
<style scoped></style>
